import { Reducer } from "redux";
import { SET_SELECTED_TSO, SET_SELECTED_TSOS } from "../actions/selectedTsosActions";

export interface SelectedTsosState {
    selectedTso: string;
    selectedTsos: string[];
}

const initialState: SelectedTsosState = {
    selectedTso: "",
    selectedTsos: [],
};

export const selectedTsosReducer: Reducer<SelectedTsosState> = (
    state: SelectedTsosState = initialState,
    action: any
): SelectedTsosState => {
    switch (action.type) {
        case SET_SELECTED_TSO:
            return { ...state, selectedTso: action.tso };
        case SET_SELECTED_TSOS:
            return { ...state, selectedTsos: action.tsos };
        default:
            return state;
    }
};
